/** @format */

import React, { Component } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';

export default class ObligacionesApagar extends Component {
  callColapsar = (art) => {
    let article = document.getElementById(art);
    article.classList.toggle("expanded");
  };
  render() {
    return (
      <>
        {this.props.objFinacesDebts.map((debts, i) => {
          return (
            <div className=" text-card" key={i + "ObligacionesPagadas"}>
              <div className="card-apagar-head">
                <div className="columna-1">{debts.docType}</div>
                <div className="columna-2">
                  {debts.numDoc == null || debts.numDoc != ""
                    ? debts.numDoc
                    : " No especificado. "}
                </div>
                <div className="columna-3">{debts.expirationDate}</div>
                <div className="columna-4">{debts.semester}</div>
                <div className="columna-5">{debts.balance}</div>
                <div className="columna-6">{debts.debtAmount}</div>
                <div className="columna-7">{debts.balance}</div>
                <div className="columna-8">
                   <i class="bi bi-chevron-down"
                   style={{ fontSize: 25 }}
                   onClick={() =>
                    this.callColapsar(`${i}_obligaciones_a_pagadas`)
                  }
                   ></i> 
                </div>
              </div>
              {/*  */}
              <article id={`${i}_obligaciones_a_pagadas`} className="article">
                <div className="text-center">
                  <div className="row align-items-start">
                    <div className="col"></div>
                    <div className="col-8">
                      <table className="table">
                        <thead className="thead-light Historial-header">
                          <tr>
                            <th scope="col">Cuota</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col" style={{ textAlign: "left" }}>
                              Descripción
                            </th>
                            <th scope="col" style={{ textAlign: "left" }}>
                              Precio Unitario
                            </th>
                            <th scope="col" style={{ textAlign: "left" }}>
                              Sub Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {debts.amountDetail.map((detail, item) => {
                            return (
                              <tr key={item}>
                                <th scope="row">{detail.fee}</th>
                                <td>{detail.amount}</td>
                                <td style={{ textAlign: "left" }}>
                                  {detail.description}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {detail.price}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {detail.subtotal}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="col"></div>
                  </div>
                </div>
              </article>
              {/*  */}
            </div>
          );
        })}
      </>
    );
  }
}
